<template>
  <b-modal
    size="md"
    id="bulkStatusBearbeitenModal"
    content-class="modal-form"
    title="Markierte Aufgaben bearbeiten"
    centered
    @show="onShow"
    @hide="onHide"
  >
    <div>
      <p class="mb-4">{{ selectedAufgabenCount }} Aufgaben ausgewählt</p>

      <b-form-group label="Neuer Status">
        <div v-if="isLoadingTriggers || statusOptions.length === 0" class="status-badge-hint">
          {{ placeholderText }}
        </div>
        <div v-else class="status-badge-options">
          <span
            v-for="option in statusOptions"
            :key="option.trigger"
            class="pill-badge status-badge-option"
            :class="{
              selected: selectedTrigger === option.trigger,
              dimmed: selectedTrigger !== null && selectedTrigger !== option.trigger,
            }"
            :style="pillColorStyleObject(option)"
            @click="selectedTrigger = option.trigger"
          >
            {{ option.label }}
          </span>
        </div>
      </b-form-group>
    </div>
    <template #modal-footer="{ hide }">
      <b-button @click="hide" :disabled="isSaving" class="dialog-btn-secondary">Abbrechen</b-button>
      <b-button
        @click="speichern(hide)"
        class="dialog-btn"
        :disabled="selectedTrigger === null || isSaving"
        variant="primary"
      >
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { LOAD_TRIGGERS, BULK_EDIT_STATUS } from '@/core/aufgaben/stores/aufgaben.module';
import { triggerLabel, aufgabenStatusColors, pillColorStyleObject } from '@/core/common/helpers/utils.js';

export default {
  props: {
    selectedAufgabenCount: { type: Number, required: true },
    selectedAufgabenIds: { type: Array, required: true },
    referenceAufgabeId: { type: Number, default: null },
  },
  data() {
    return {
      selectedTrigger: null,
      availableTriggers: [],
      isLoadingTriggers: false,
      isSaving: false,
    };
  },
  computed: {
    // Erlaubte Statuswechsel als Badge-Optionen mit Label und Farben
    statusOptions() {
      return this.availableTriggers
        .filter(t => t.allowed)
        .map(t => {
          const status = t.trigger.replace('Trigger', '');
          const colors = aufgabenStatusColors[status];
          const label = triggerLabel(t.trigger);
          return colors && label ? { trigger: t.trigger, label, ...colors } : null;
        })
        .filter(Boolean);
    },
    placeholderText() {
      if (this.isLoadingTriggers) return 'Lade Status...';
      if (this.statusOptions.length === 0) return 'Keine Statuswechsel verfügbar';
      return 'Status auswählen...';
    },
  },
  methods: {
    pillColorStyleObject,
    async onShow() {
      this.selectedTrigger = null;
      this.availableTriggers = [];
      if (!this.referenceAufgabeId) return;

      this.isLoadingTriggers = true;
      try {
        const triggers = await this.$store.dispatch(LOAD_TRIGGERS, {
          aufgabeId: this.referenceAufgabeId,
        });
        this.availableTriggers = triggers || [];
      } catch (error) {
        console.error('Trigger konnten nicht geladen werden:', error);
        this.availableTriggers = [];
      } finally {
        this.isLoadingTriggers = false;
      }
    },
    onHide() {
      this.selectedTrigger = null;
      this.availableTriggers = [];
      this.isSaving = false;
    },
    async speichern(hide) {
      if (this.selectedTrigger === null) return;

      this.isSaving = true;
      try {
        await this.$store.dispatch(BULK_EDIT_STATUS, {
          aufgabeIds: this.selectedAufgabenIds,
          trigger: this.selectedTrigger,
        });
        this.toast('Status erfolgreich bearbeitet.');
        this.$emit('bulkStatusBearbeitet', this.selectedTrigger);
        hide();
      } catch (error) {
        console.error('Bulk-Status konnte nicht bearbeitet werden:', error);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
<style scoped>
.status-badge-hint {
  font-size: 14px;
  color: #adadad;
}

.status-badge-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-badge-option {
  cursor: pointer;
  transition: opacity 0.15s, box-shadow 0.15s;
}

.status-badge-option.dimmed {
  opacity: 0.45;
}

/* Hervorhebung des gewählten Status durch Ring in der dunklen Status-Textfarbe */
.status-badge-option.selected {
  box-shadow: 0 0 0 2px currentColor;
}
</style>
